import {
  AutoComplete,
  AutoCompleteChangeEvent,
  AutoCompleteCompleteEvent,
  AutoCompleteSelectEvent,
} from "primereact/autocomplete";
import { useEffect, useState } from "react";

import { getStations } from "../services/sl";
import { Station } from "../types/station";

export function SearchDeparture({
  onSelect,
  value,
  className,
}: {
  onSelect: (station: Station) => void;
  value: Station | null;
  className?: string;
}) {
  const [internalValue, setInternalValue] = useState<Station | string | null>(
    value,
  );
  const [filteredStations, setfilteredStations] = useState<Station[]>([]);

  useEffect(() => {
    setInternalValue(value);
  }, [value]);

  return (
    <AutoComplete
      forceSelection
      className={className}
      completeMethod={(event: AutoCompleteCompleteEvent) => {
        (async () => {
          const stations = (await getStations()).filter((station) =>
            station.name
              .toLowerCase()
              .startsWith(event.query.toLowerCase() ?? ""),
          );
          setfilteredStations(stations);
        })();
      }}
      field="name"
      suggestions={filteredStations}
      value={internalValue}
      onChange={({ value }: AutoCompleteChangeEvent<Station>) => {
        if (value) {
          setInternalValue(value);
        }
      }}
      onSelect={(e: AutoCompleteSelectEvent<Station>) => onSelect(e.value)}
    />
  );
}
